(() => {
  let trigger;
  let wasOpen = false;
  const scope = ':is(.collection-default, .search-container)';
  const sidebar = () => document.querySelector(`${scope} #halo-sidebar`);
  const focusable = (panel = sidebar()) => [...(panel?.querySelectorAll('button, a[href], input, select, [tabindex="0"]') || [])]
    .filter(element => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility === 'visible');
  document.addEventListener('click', event => {
    const descriptionToggle = event.target.closest('.alwan-collection-description-toggle');
    if (descriptionToggle) {
      const description = descriptionToggle.closest('[data-alwan-description]');
      const collapse = descriptionToggle.getAttribute('aria-expanded') === 'true';
      const top = description.getBoundingClientRect().top;
      description.classList.toggle('is-collapsed', collapse);
      descriptionToggle.setAttribute('aria-expanded', String(!collapse));
      if (collapse && top < 0) {
        const title = description.closest('.articleLookbook-item')?.querySelector('.articleLookbook-title');
        (title || description).scrollIntoView({block: 'center'});
      }
      descriptionToggle.focus({preventScroll: true});
    }
    const button = event.target.closest(`${scope} [data-sidebar]`);
    if (button) trigger = button;
  });
  // Sort is a Dropdown (select[data-alwan-sort]); apply it the way Ella's sort menu did.
  document.addEventListener('change', event => {
    const select = event.target.closest('select[data-alwan-sort]');
    if (!select) return;
    const filters = document.querySelector('collection-filters-form');
    const sortField = filters?.querySelector('[name="sort_by"]');
    if (window.show_storefront_filter && sortField) {
      sortField.value = select.value;
      filters.onSubmitHandlerFromSortBy(event, filters.querySelector('form'));
      return;
    }
    const toolbar = select.closest('toolbar-item');
    if (toolbar && typeof toolbar.renderPage === 'function') {
      Shopify.queryParams.sort_by = select.value;
      toolbar.updateURLHash();
      toolbar.renderPage(toolbar.createURLHash());
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url);
  });
  new MutationObserver(() => {
    if (!sidebar()) return;
    const open = document.body.classList.contains('open-mobile-sidebar');
    document.querySelectorAll(`${scope} [data-sidebar]`).forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open && !wasOpen) {
      // Ella transitions the drawer's visibility; wait until its controls can receive focus.
      setTimeout(() => {
        if (document.body.classList.contains('open-mobile-sidebar')) focusable()[0]?.focus();
      }, 250);
    }
    if (!open && wasOpen) {
      (trigger?.isConnected ? trigger : document.querySelector(`${scope} [data-sidebar]`))?.focus({preventScroll: true});
    }
    wasOpen = open;
  }).observe(document.body, {attributes: true, attributeFilter: ['class']});
  document.addEventListener('keydown', event => {
    const panel = document.body.classList.contains('open-mobile-sidebar') ? sidebar() : null;
    if (panel) {
      if (event.key === 'Escape') {
        event.preventDefault();
        document.body.classList.remove('open-mobile-sidebar');
        requestAnimationFrame(() => {
          document.querySelector(`${scope} [data-sidebar]`)?.focus({preventScroll: true});
        });
      }
      if (event.key === 'Tab') {
        const items = focusable(panel);
        const first = items[0];
        const last = items.at(-1);
        if (!panel.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first)?.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    }
    const target = event.target.closest(`${scope} [data-toggle], ${scope} [data-sort-by-item]`);
    if (target && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); target.click();
    }
  });
  const enhance = () => {
    document.querySelectorAll('[data-alwan-description]:not([data-description-ready])').forEach(description => {
      description.dataset.descriptionReady = 'true';
      const body = description.querySelector('.alwan-collection-description-body');
      const button = description.querySelector('.alwan-collection-description-toggle');
      const update = () => {
        const lines = [];
        const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          if (!walker.currentNode.textContent.trim()) continue;
          const range = document.createRange();
          range.selectNodeContents(walker.currentNode);
          for (const rect of range.getClientRects()) {
            if (rect.width && rect.height && !lines.some(line => Math.abs(line.top - rect.top) < 2)) lines.push(rect);
          }
          if (lines.length > 4) break;
        }
        lines.sort((a, b) => a.top - b.top);
        const previewHeight = lines[3] ? Math.ceil(lines[3].bottom - body.getBoundingClientRect().top + 2) : body.scrollHeight;
        description.style.setProperty('--description-preview-height', `${previewHeight}px`);
        const expandable = lines.length > 4 || body.scrollHeight > previewHeight + 1;
        button.hidden = !expandable;
        if (!expandable) {
          description.classList.remove('is-collapsed');
          button.setAttribute('aria-expanded', 'true');
        } else if (!description.dataset.descriptionMeasured) {
          description.classList.add('is-collapsed');
          button.setAttribute('aria-expanded', 'false');
        }
        description.dataset.descriptionMeasured = 'true';
      };
      update();
      new ResizeObserver(update).observe(body);
    });
    document.querySelectorAll('.collection-default [data-sort-by-item], .collection-default [data-toggle]').forEach(element => {
      element.tabIndex = 0;
      element.setAttribute('role', 'button');
    });
  };
  enhance();
  new MutationObserver(enhance).observe(document.querySelector('#CollectionProductGrid') || document.body, {childList: true, subtree: true});
})();
